const getPrettyTypeName = (nameType: 'blog_post' | 'guides_post' | 'case_studies_post'): string => {
  switch (nameType) {
    case 'blog_post':
      return 'blog';
    case 'guides_post':
      return 'guides';
    case 'case_studies_post':
      return 'case studies';
    default:
      return 'blog';
  }
};

export default getPrettyTypeName;
